import { isChrome } from 'react-device-detect';
import { EFontWeights } from 'utils/enums';
import { PaymentMethodData, PaymentModalProps } from './types';
import { Modal } from '../Modal';
import { PaymentMethod } from './PaymentMethod';
import { StyledPaymentButtonsContainer } from './style';
import { useApplePay } from 'utils';
import PaypalWrapper from './PaypalWrapper';

export const PaymentModal: React.FC<PaymentModalProps> = ({
  headerText,
  headerColor,
  headerSize,
  headerWeight = EFontWeights.Bold,
  text,
  textColor,
  textSize,
  textWeight = EFontWeights.Normal,
  closeModal,
  paymentClicked,
  modalColor,
  modalBorderColor,
  buttonColor,
  buttonTextColor,
  preview,
  fontFamily,
  paymentMethods,
  paypalButton,
  showOverlay = true,
  showCloseButton = true,
  visible,
}) => {
  const { isApplePayAvailable } = useApplePay();

  const customButton = (paymentMethodData: PaymentMethodData) => {
    return (
      <PaymentMethod
        buttonText={
          paymentMethodData.paymentMethodName === 'card'
            ? paymentMethodData.paymentMethodDisplayName
            : ''
        }
        key={paymentMethodData.paymentMethodName}
        checkoutWithCard={() =>
          paymentClicked(paymentMethodData.paymentMethodName)
        }
        buttonColor={buttonColor}
        buttonTextColor={buttonTextColor}
        icon={paymentMethodData.paymentMethodAssetUrl}
      />
    );
  };

  const applePayButton = (
    <div className="button" key="apple" onClick={() => paymentClicked('apple')}>
      <img
        alt="apple pay"
        src="https://media.appcharge.com/defaults/apple_pay_white.svg"
      />
    </div>
  );

  const googlePayButton = (
    <div
      className="button"
      key={'google'}
      onClick={() => paymentClicked('google')}
    >
      <img
        alt="google pay"
        src="https://media.appcharge.com/defaults/google_pay_white.svg"
      />
    </div>
  );

  const getGoogleBtnComponent = () => {
    if (!isChrome) return null;
    return !isApplePayAvailable
      ? googlePayButton
      : preview
      ? googlePayButton
      : null;
  };

  const paymentMethodsButtons = {
    apple: isApplePayAvailable
      ? applePayButton
      : preview
      ? applePayButton
      : null,
    google: getGoogleBtnComponent(),
    paypal: (
      <PaypalWrapper
        preview={preview}
        paypalButton={paypalButton}
        key="paypal"
      />
    ),
  };

  return (
    <Modal
      title={headerText}
      titleColor={headerColor}
      titleSize={headerSize}
      titleWeight={headerWeight}
      subtitle={text}
      subtitleColor={textColor}
      subtitleSize={textSize}
      closeModal={closeModal}
      modalColor={modalColor}
      modalBorderColor={modalBorderColor}
      fontFamily={fontFamily}
      preview={preview}
      showOverlay={showOverlay}
      showCloseButton={showCloseButton}
      visible={visible}
    >
      <StyledPaymentButtonsContainer>
        {paymentMethods.map((paymentMethod: PaymentMethodData) => {
          if (paymentMethod.paymentMethodName === 'apple') {
            return paymentMethodsButtons[paymentMethod.paymentMethodName];
          }
        })}
        {paymentMethods.map((paymentMethod: PaymentMethodData) => {
          if (paymentMethod.paymentMethodName === 'card') {
            return customButton(paymentMethod);
          }
        })}
        {paymentMethods
          .filter(
            (paymentMethod: PaymentMethodData) =>
              paymentMethod.paymentMethodName !== 'blik_checkout' &&
              paymentMethod.paymentMethodName !== 'apple' &&
              paymentMethod.paymentMethodName !== 'card',
          )
          .map((paymentMethod: PaymentMethodData) => {
            if (
              paymentMethod.paymentMethodName === 'google' ||
              paymentMethod.paymentMethodName === 'paypal'
            ) {
              return paymentMethodsButtons[paymentMethod.paymentMethodName];
            } else {
              return customButton(paymentMethod);
            }
          })}
      </StyledPaymentButtonsContainer>
    </Modal>
  );
};
